<label
    for="citizen-agency"
    id="citizen-agency-label"
    [innerHTML]="
        'dynamische_frontend_texte.landing.html_content.label_dropdown_dienststelle' | translate | required | safeStyle
    "
></label>
<ng-select
    id="citizen-agency"
    [items]="agenciesSelect"
    bindLabel="name"
    bindValue="id"
    (change)="onAgencySelect($event)"
    formControlName="agency"
    [clearable]="false"
    [markFirst]="false"
    placeholder="Dienststelle auswählen"
    [loading]="agenciesRequestLoading"
    loadingText="Lade Dienststellen..."
    notFoundText="Keine Einträge gefunden"
    [inputAttrs]="{ 'aria-describedby': 'citizen-agency-error', 'aria-labelledby': 'citizen-agency-label' }"
    dropdownCustomHoverColorDirective
    otbAnnounceSearchResults
></ng-select>
<otb-form-error-message id="citizen-agency-error" [show]="formAgency.invalid && formAgency.dirty">
</otb-form-error-message>
